import type { LiveQuote } from "~/v3-poc/api/snapshotStream";

/** Latest-value quote batches are delivered on this fixed interval. */
export const QUOTE_FLUSH_MS = 250;

export interface AccountRef {
  /** Socket identity — account id, product and status joined. */
  readonly key: string;
  /** Built in the window: a worker has no `window` to read env or location from. */
  readonly socketUrl: string;
}

export interface ClientState {
  readonly visible: boolean;
  readonly symbols: readonly string[];
}

export interface WorkerState {
  readonly clients: ReadonlyMap<string, ClientState>;
  readonly account: AccountRef | undefined;
  /** Whether a socket has been asked for — not whether it is connected. */
  readonly socket: "idle" | "started";
  /** Last union handed to the socket; guards redundant `socket.symbols`. */
  readonly sent: readonly string[];
  /** Warm-start cache: a new window gets prices without waiting for a tick. */
  readonly lastQuotes: ReadonlyMap<string, LiveQuote>;
  /** Coalescing buffer, latest wins per symbol. */
  readonly pending: ReadonlyMap<string, LiveQuote>;
  readonly flushTimer: "idle" | "armed";
}

export const initialWorkerState: WorkerState = {
  clients: new Map(),
  account: undefined,
  socket: "idle",
  sent: [],
  lastQuotes: new Map(),
  pending: new Map(),
  flushTimer: "idle",
};
